import {createContext, PropsWithChildren, useMemo} from "react";
import {Category} from "../../../../api/Products";
import {useGetAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";

export const CategoryContext = createContext({
    categories: [] as Category[],
    result: [] as Category[],
    loading: true,
    error: null as any,
    reload: () => {},

    getNamePath: (id: number) => {
        return [] as string[];
    },

    getIdPath: (id: number) => {
        return [] as number[];
    },

    getDescendantIds: (id: number) => {
        return [] as number[];
    },
})

const blankArray = [] as any;

export function CategoryProvider(props: PropsWithChildren<{
    mode: any;
}>) {
    const mode = props.mode;
    const load = useGetAll((input) => api.products.categories(input), {
        kind: mode || undefined as any
    }, [mode]);

    const categories = load.asList || blankArray;
    const loading = load.loading;
    const error = load.error;
    const reload = load.reload;

    const ctx = useMemo(() => {
        const getPath = (id: number) => {
            const path: Category[] = [];
            let current = categories.find(c => c.id === id);

            while(current) {
                path.unshift(current);

                const cur: Category = current;
                current = cur.parentCategory ? categories.find(c => c.id === cur.parentCategory) : undefined;
            }

            return path;
        }

        return {
            categories,
            result: categories,
            loading,
            error,
            reload,
            getNamePath: (id: number) => getPath(id).map(c => c.name),
            getIdPath: (id: number) => getPath(id).map(c => c.id),
            getDescendantIds: (id: number) => {
                const list: number[] = [];
                let parents = [id];

                while(parents.length > 0) {
                    const children = categories.filter(c => c.parentCategory && parents.includes(c.parentCategory)).map(c => c.id);
                    list.push(...children);
                    parents = children;
                }

                return list;
            },
        }
    }, [
        categories,
        loading,
        error,
        reload
    ]);

    return (
        <CategoryContext.Provider value={ctx}>
            {props.children}
        </CategoryContext.Provider>
    )
}